import React from 'react';
import SectionText from '../../presentational/SectionText';
import data from '../../../core/data';
import Image from '../../presentational/Image';

import nudeBBCream from '../../../images/bb-cream/bb-cream-nude.jpg';

function WhatIsBBContainer(props) {
  return (
    <section id="what-is-bb">
      <div className="container">
        <h1>What is the BB Cream?</h1>
        <div className="row">
          <div className="col-md-6">
            <SectionText heading="In congue fermentum tortor." body={ data.bbcream.whatIsBB.body } />
          </div>
          <div className="col-md-5 col-md-offset-1">

          </div>
        </div>
      </div>
    </section>
  )
}

export default WhatIsBBContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/BBPage/WhatIsBBContainer.jsx
 **/